import React, { useMemo } from 'react'
import { Col, Row } from "antd";
import WeddingSection from './WeddingSection'
import { Lunar } from 'lunar-javascript';
import { Image } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';

const weekdays = ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"];

function TimeLineItem({ item }) {
    return <div style={{
        position: "absolute",
        left: item.left,
        transform: "translate(-50%, -7px)",
        width: "33%",
        textAlign: "center",
    }}>
        <div className='primary-background-color' style={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translate(-50%, -100%)",
            borderRadius: "50%",
        }}>
            <img src={item.img} width={45} alt='time-line-img'/>
        </div>
        <div style={{
            backgroundColor: "white",
            height: 10,
            width: 10,
            margin: "auto",
            borderRadius: 5,
        }} />
        <div style={{
            position: "absolute",
            top: 10,
            left: "50%",
            transform: "translateX(-50%)",
        }}>
            <div style={{
                fontSize: 15
            }}>
                {item.time}
            </div>
            <div style={{ 
                whiteSpace: "pre-line",
                textTransform: "uppercase",
                fontSize: 9
            }}>
                {item.text}
            </div>
        </div>
    </div>
}

function TimeLine({ selectedWeddingInfo, invitation }) {
    return <div className="primary-background-color no-wedding-padding-x" style={{
        color: "white",
        paddingTop: 70,
        paddingBottom: 75,
        position: "relative",
    }}>
        <div style={{
            backgroundColor: "white",
            width: "100%",
            height: 3,
            borderRadius: 3,
        }} />
        <TimeLineItem item={{
            img: '/img/white-flower-gate-icon.png',
            left: "15%",
            time: invitation?.data?.open_time || selectedWeddingInfo.open_time.format("HH:mm"),
            text: "Đón tiếp\nkhách mời"
        }}/>
        <TimeLineItem item={{
            img: '/img/white-ring-icon.png',
            left: "50%",
            time: invitation?.data?.ritual_time || selectedWeddingInfo.ritual_time.format("HH:mm"),
            text: `Bắt đầu\n${selectedWeddingInfo.display}`
        }}/>
        <TimeLineItem item={{
            img: '/img/white-dinner-icon.png',
            left: "85%",
            time: invitation?.data?.party_time || selectedWeddingInfo.party_time.format("HH:mm"),
            text: "Khai tiệc\nchúc mừng"
        }}/>
    </div>
}

export default function InvitationInfoSection({ type, styleSection = 0, weddingInfo, place, invitation }) {
    // type = "saigon" | "hanoi"
    // style = 0 | 1
    const selectedWeddingInfo = useMemo(() => {
        if (place) {
            return {
                ...place,
                lunarDate: Lunar.fromDate(place.open_time.toDate())
            };
        }
        const result = weddingInfo.find(item => item.tab === type);
        if (!result) return null;
        return {
            ...result,
            lunarDate: Lunar.fromDate(result.open_time.toDate())
        }
    }, [weddingInfo, type, place])

    const colorClass = "primary-color";
    // const colorClass = styleSection === 0 ? "primary-color" : "secondary-color";
    // const backgroundColorClass = styleSection === 0 ? "secondary-background-color" : "primary-background-color";

    return selectedWeddingInfo &&
        <WeddingSection >

            <div
                className={`no-wedding-padding-y`}
                        // no-wedding-padding-x
                        // ${backgroundColorClass}
                        // `}
                style={{
                    padding: "50px 0px 0px",
                    textAlign: "center",
                }}>
                <div style={{
                    textAlign: 'center',
                    position: "relative",
                    width: "100%"
                }}>
                    <div>
                        <Image alt="wedding-info-header-bg" src="/img/wedding-info-header-bg.png" width="70%" preview={false} />
                    </div>

                    <div
                        className={`primary-font ${colorClass}`}
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontSize: "40px",
                            fontWeight: "500",
                            whiteSpace: "nowrap"
                        }}>
                        {selectedWeddingInfo.display}
                    </div>
                </div>


                <div className={`primary-font ${colorClass}`}
                    style={{
                        fontSize: "25px",
                        fontWeight: "600",
                        textTransform: "uppercase"
                        // fontSize: "clamp(22px, 3vw, 30px)",
                    }}>
                    {weekdays[selectedWeddingInfo.open_time.day()]}
                </div>

                <div style={{
                    marginBottom: 30
                }}>
                    <Row style={{ marginBottom: 10 }} gutter={10}>
                        <Col span={1}></Col>
                        <Col span={8} className={` ${colorClass}`} style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // fontSize: "clamp(22px, 3vw, 30px)",
                            fontWeight: "500",
                            fontSize: "22px",
                            fontFamily: "'EB Garamond', serif"
                            // lineHeight: "22px"
                        }}>
                            <div className='border-top-down'>
                                THÁNG {selectedWeddingInfo.open_time.format("MM")}
                            </div>
                        </Col>
                        <Col span={6} className={` ${colorClass}`} style={{
                            // textAlign: "center",
                            // fontSize: "clamp(32px, 3vw, 40px)",
                            fontSize: "70px",
                            // lineHeight: "0.7"
                            height: "70px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontFamily: "'EB Garamond', serif"
                        }}>
                            {selectedWeddingInfo.open_time.format("DD")}
                        </Col>
                        <Col span={8} className={` ${colorClass}`} style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // fontSize: "clamp(22px, 3vw, 30px)",
                            fontWeight: "500",
                            fontSize: "22px",
                            fontFamily: "'EB Garamond', serif"
                        }}>
                            <div className='border-top-down'>
                                NĂM {selectedWeddingInfo.open_time.format("YYYY")}
                            </div>

                        </Col>
                    </Row>

                    <div className={` ${colorClass}`}
                        style={{
                            fontStyle: "italic",
                            // textAlign: "center",
                            // fontFamily: "'Gowun Dodum', sans-serif",
                            fontFamily: "'EB Garamond', serif",
                            // fontWeight: "500",
                            fontSize: "14px",
                        }}>
                        (Tức ngày {String(selectedWeddingInfo.lunarDate.getDay()).padStart(2, "0")} tháng {String(selectedWeddingInfo.lunarDate.getMonth()).padStart(2, "0")} năm Bính Ngọ)
                    </div>
                </div>

                <div className={` ${colorClass}`}
                    style={{
                        // textAlign: "center",
                        // marginBottom: 50,
                        fontFamily: "'EB Garamond', serif",
                    }}>
                    <div style={{
                        fontSize: "18px",
                        fontWeight: "500"
                    }}>
                        Tổ chức tại
                    </div>
                    <div
                        className={`primary-font ${colorClass}`}
                        style={{
                            fontWeight: "bold",
                            fontSize: "25px",
                            fontFamily: "'EB Garamond', sans-serif",
                            // fontFamily: "'EB Garamond', sans-serif",
                            // fontFamily: "'Gowun Dodum', sans-serif",
                            letterSpacing: "1px"
                            // marginBottom: 10,
                        }}>
                        {selectedWeddingInfo.name_place}
                    </div>
                    <div style={{
                        fontStyle: "italic",
                        fontFamily: "'Gowun Dodum', sans-serif",
                        fontWeight: "300",
                        fontSize: "14px",
                        // letterSpacing: "0.5px"
                        // marginBottom: 10,
                    }}>
                        ({selectedWeddingInfo.address})
                    </div>
                    <div style={{
                        margin: "15px 0px 40px",
                    }}>
                        <a className={`pulsetext ${colorClass}`} href={selectedWeddingInfo.map} 
                            target='_blank' rel='noreferrer'
                            style={{
                                fontWeight: "600",
                                fontSize: "17px"
                        }}>
                            <EnvironmentOutlined /> CHỈ ĐƯỜNG
                        </a>
                    </div>
                </div>

                <TimeLine selectedWeddingInfo={selectedWeddingInfo} invitation={invitation}/>
                
                {/* <CountDown time={selectedWeddingInfo.open_time}/> */}
            </div>
        </WeddingSection>
}
